import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import { Entity } from "../../../../types/types";
import axios from "../../../../api/axios";

import { entityKeys } from "../queryKeys";

export const useEntityDetails = (entityId: string) => {
  const { i18n } = useTranslation();
  return useQuery<Entity>({
    queryKey: [...entityKeys.details(entityId), i18n.language],
    queryFn: async () => {
      const { data } = await axios.get(`/football-entities/${entityId}/`);
      return data;
    },
    enabled: !!entityId,
  });
};
